
/**
 * Shared style mappings for premium bot components
 */

/**
 * Map color schemes to CSS classes for cards
 */
export const colorSchemeStyles: Record<string, string> = {
  royal_purple: 'card-scheme-royal-purple',
  ocean_blue: 'card-scheme-ocean-blue',
  emerald_green: 'card-scheme-emerald-green',
  ruby_red: 'card-scheme-ruby-red',
  amber_gold: 'card-scheme-amber-gold',
  midnight_black: 'card-scheme-midnight-black',
  coral_orange: 'card-scheme-coral-orange',
};

/**
 * Map color schemes to text colors for icons
 */
export const iconColorMap: Record<string, string> = {
  royal_purple: 'text-botscheme-royal-purple',
  ocean_blue: 'text-botscheme-ocean-blue',
  emerald_green: 'text-botscheme-emerald-green',
  ruby_red: 'text-botscheme-ruby-red',
  amber_gold: 'text-botscheme-amber-gold',
  midnight_black: 'text-gray-900',
  coral_orange: 'text-botscheme-coral-orange',
};

/**
 * Default card styles based on bot type
 */
export const defaultCardStyles = {
  user_bot: 'card-gradient-personal',
  premium_bot: 'card-gradient-premium',
  prop_bot: 'card-gradient-prop'
};

/**
 * Default icon styles based on bot type
 */
export const defaultIconStyles = {
  user_bot: 'text-tradebrand-green',
  premium_bot: 'text-tradebrand-purple',
  prop_bot: 'text-tradebrand-blue'
};

/**
 * Status badge styles
 */
export const statusStyles = {
  active: 'bg-green-500/20 text-green-500 border-green-500/30',
  inactive: 'bg-gray-500/20 text-gray-400 border-gray-500/30'
};
